import Archiver from './archiver'

if (!TransformStream) {
    window.TransformStream = WebStreamsPolyfill.TransformStream
}

export {
    Archiver
}
